import { Grid } from '@mui/material';
import { CuriosityAutocomplete, CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { Address } from '~/components/Address/Address';
import { CurrencySelect } from '~/components/CurrencySelect/CurrencySelect';
import { useFormFieldErrorTranslation } from '~/hooks';

type IntakeRequestDetailsFormProps = { disabled?: boolean };

export const IntakeRequestDetailsForm = ({ disabled }: IntakeRequestDetailsFormProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeRequestDetailsStepForm' });

  const { errorToHelperText } = useFormFieldErrorTranslation();
  return (
    <Grid container spacing={4} size={12}>
      <Grid size={12}>
        <Controller
          name="organizationId"
          render={({ field, fieldState: { error } }) => {
            return (
              <CuriosityAutocomplete
                ns={CuriosityNamespaceType.ORGANIZATION}
                fullWidth={true}
                multiple={false}
                simplifyValue
                {...field}
                TextFieldProps={{
                  error: !!error,
                  helperText: errorToHelperText(error),
                  label: t('organization'),
                  fullWidth: true,
                  variant: 'standard',
                  required: true,
                }}
                disabled={disabled || field.disabled}
              />
            );
          }}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name="deliveryLocationId"
          render={({ field, fieldState: { error } }) => {
            return (
              <CuriosityAutocomplete
                ns={CuriosityNamespaceType.LOCATION}
                fullWidth={true}
                multiple={false}
                simplifyValue
                {...field}
                TextFieldProps={{
                  error: !!error,
                  helperText: errorToHelperText(error),
                  label: t('deliveryLocation'),
                  fullWidth: true,
                  variant: 'standard',
                }}
                renderOption={(option) => <Address {...option} />}
                disabled={true}
              />
            );
          }}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name="commodityGroupId"
          render={({ field, fieldState: { error } }) => {
            return (
              <CuriosityAutocomplete
                ns={CuriosityNamespaceType.COMMODITY_GROUP}
                fullWidth={true}
                multiple={false}
                simplifyValue
                {...field}
                TextFieldProps={{
                  error: !!error,
                  helperText: errorToHelperText(error),
                  label: t('commodityGroup'),
                  fullWidth: true,
                  variant: 'standard',
                  required: true,
                }}
                disabled={disabled || field.disabled}
              />
            );
          }}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name="currency"
          defaultValue=""
          render={({ field, fieldState: { error } }) => (
            <CurrencySelect
              {...field}
              error={!!error}
              helperText={errorToHelperText(error)}
              disabled={disabled || field.disabled}
              required
              fullWidth
              variant="standard"
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
